module.exports = __webpack_public_path__ + "img/logoManokip.1a32abb6.png";